export class Cliente {
    idCliente: number;
    nombre: string;
    telefono: string;
    direccion: string;
    contacto: string;
    email: string;
    celular: string;
    oficina: string;
    rfc: string;
    domicilioFiscal: string;
    razonSocial: string;
    diasCredito: number;
    seleccionado: boolean;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/cliente.ts